import React from 'react';

const Skills = () => {
    return (
        <div>
            <h1>Skills Page</h1>
        </div>
    );
};

export default Skills;